import React from 'react'
import { SessionStore } from '../../stores'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'

@inject('adminStore', 'sessionStore')
@observer
class SessionMessage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      ready: false,
      isLoading: false
    }
    this.logout = this.logout.bind(this)
  }

  logout () {
    this.props.sessionStore.setLastError(null)
    window.location.href = '/login'
    this.props.sessionStore.destroySession()
    this.props.sessionStore.destroy()
    document.querySelector('#overlayBG').classList.remove('d-block')
    document.querySelector('#overlayBG').classList.add('d-none')
  }

  render () {
    return (
      <div id='overlayBG' className='d-none'>
        <div className='bg-dark' id='sessionMessage'>
          <p id='overlayBGText'>Your session has expired. Please log in again.</p>
          <button className='btn btn-primary' onClick={this.logout} disabled={this.state.isLoading}>Log in</button>
        </div>
      </div>
    )
  }
}

SessionMessage.propTypes = {
  sessionStore: PropTypes.instanceOf(SessionStore)

}

export { SessionMessage }
